import React from 'react'
import NotFound from 'scripts/components/notfound'
import { connect } from 'scripts/store'
import Constants from 'scripts/base/Constants'

export default function RequireAuth(Component) {
  class reqauth extends React.Component {
    constructor(props) {
      super(props)
      this.state = {auth: props.auth, user: props.user, logout: props.logout}
    }

    componentWillReceiveProps(nextProps) {
      this.setState({auth: nextProps.auth, user: nextProps.user, logout: nextProps.logout})
    }

    render() {
      const {auth, user, logout} = this.state
      if (logout === true) {
        window.location = '/'
        return null
      }
      if (!auth && !user) { return null }
      if (auth === Constants.Auth.NO) { return <NotFound /> }
      return <Component {...this.state} {...this.props} />
    }
  }

  const mapToProps = ({auth, user, logout}) => {
    return {auth, user, logout}
  }
  return connect(mapToProps)(reqauth)
}



// WEBPACK FOOTER //
// ./assets/js/components/base/RequireAuth.jsx